import { Field } from 'Util/Query';

/** @namespace Pwa/Query/SocialShare/Query */
export class SocialShareQuery {
    getSocialShareQuery() {
        return new Field('storeConfig').addFieldList(this._getFieldList());
    }

    _getFieldList() {
        return [
            'mpss_enabled',
            'mpss_fb_enabled',
            'mpss_twitter_enabled',
            'mpss_messenger_enabled',
            'mpss_pinterest_enabled',
            'mpss_linkedin_enabled',
            'mpss_tumblr_enabled',
        ];
    }
}

export default new SocialShareQuery();
